import {Component, ViewChild} from '@angular/core';
import {App, Content, Events, NavController, NavParams, PopoverController, Refresher} from 'ionic-angular';
import {Job} from "../job/shared/job.model";
import {JobService} from "../job/shared/job.service";
import {RoleService} from "../../app/core/role.service";
import 'rxjs/add/operator/switchMap';
import {JobPage} from "../job/job.page";
import {MenuComponent} from "../../app/components/menu/menu.component";
import {AppAuth} from "../../app/core/auth";

@Component({
  selector: 'page-jobs-list',
  templateUrl: 'jobs-list.page.html',
})
export class JobsListPage {
  @ViewChild(Content) content: Content;
  jobs: Job[] = [];
  filter: string;
  private refresher: Refresher;
  jobsSub: any;
  role: string;
  roleSub: any;
  roleObs: any;
  state: { user_id: number };
  stateSub: any;
  stateObs: any;
  private nav: NavController;

  constructor(private jobService: JobService,
              private navParams: NavParams,
              private events: Events,
              private roleService: RoleService,
              private popoverCtrl: PopoverController,
              public auth: AppAuth,
              private app: App) {
    this.nav = this.app.getRootNav();
  }


  openMenu(event) {
    let menu = this.popoverCtrl.create(MenuComponent);
    menu.present({
      ev: event,
    });
  }

  goToNewJobPage() {
    this.nav.push(JobPage);
  }

  refreshJobs(refresher: Refresher) {
    this.refresher = refresher;
    this.getJobs(this.filter);
  }

  private getJobs(filter) {
    // Wait for role and state before getting jobs
    this.jobsSub && this.jobsSub.unsubscribe();

    this.jobsSub = this.roleObs.switchMap((role) => {
      return this.stateObs.switchMap(state => {
        let jobsObs;
        if (filter === 'public') {
          jobsObs = this.jobService.getPublicJobs();
        } else {
          jobsObs = this.jobService.getMyJobs(filter, role, state.user_id);
        }
        return jobsObs
          .finally(() => this.refresher && this.refresher.complete());
      });
    })
      .subscribe(jobs => this.jobs = jobs)
  }

  ionViewWillEnter() {
    this.content.resize();

    this.roleObs = this.roleService.getRole();
    this.roleSub = this.roleObs
      .subscribe(role => this.role = role);

    this.stateObs = this.jobService.getCollectionState();
    this.stateSub = this.stateObs
      .subscribe(state => this.state = state);

    this.events.subscribe('JobsUpdated', () => this.getJobs(this.filter));

    this.filter = this.navParams.get('filter');

    this.getJobs(this.filter);
  }

  ionViewWillLeave() {
    this.events.unsubscribe('JobsUpdated');
    this.jobsSub && this.jobsSub.unsubscribe();
    this.roleSub.unsubscribe();
    this.stateSub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/pages/jobs-list/jobs-list.page.ts